module.exports = __webpack_public_path__ + "img/2.e7a5e900.jpg";